




















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { LearningRequest as ILearningRequest } from "@/api/models/learning-request";
import { Employee as IEmployee } from "@/api/models/employee";
import api from "@/getinfo-api";

@Component
export default class OrderItemCard extends Vue {
  @Prop() request!: ILearningRequest;
  isNew?: boolean = true;

  get resourceType() {
    let resource;
    switch (this.request.resourceType) {
      case "course":
        resource = this.$tc(this.$translate.Course);
        break;
      case "webinar":
        resource = this.$tc(this.$translate.Webinar);
        break;
      case "video":
        resource = this.$tc(this.$translate.Record);
        break;
      case "record":
        resource = this.$tc(this.$translate.Record);
        break;
      default:
        resource = this.$tc(this.$translate.LearningMaterial);
    }
    return resource;
  }

  goToProfile() {
    api.EmployeeApi.get(
      this.request.companyId,
      this.request.responsibleId
    ).then((res: { data: IEmployee }) => {
      this.$router.push({
        name: "userProfileView",
        params: { id: res.data.user.id }
      });
    });
  }

  created() {
    setTimeout(() => {
      this.isNew = false;
    }, 3000);
  }
}
